import React from 'react';

// Styles & Assets
import styles from './AssignDeviceButton.module.css';

// Services
import { isDeviceOnLoan } from '../../../services/DevicesHelpers';

// Hooks
import { useState } from 'react';

// Components
import Modal from '../../UI/Modal/Modal';
import DialogAssignDevice from '../DialogAssignDevice/DialogAssignDevice';
import DialogWithdrawDevice from '../DialogWithdrawDevice/DialogWithdrawDevice';

// Interfaces
import { Device, DeviceLoanPatient } from '../../../interfaces/Device';

// Language
import { useTranslation } from 'react-i18next';

const AssignDeviceButton: React.FC<{
    device: Device
    widtdrawDeviceLocally: (deviceID: Device["id"]) => void
    assignDeviceLocally: (deviceLoan: DeviceLoanPatient) => void
}> = ({ device, widtdrawDeviceLocally, assignDeviceLocally }) => {

    const { t } = useTranslation();

    const deviceOnLoan = isDeviceOnLoan(device);

    const [showAssignDialog, setShowAssignDialog] = useState<boolean>(false);

    return (
        <>
            <button
                onClick={() => setShowAssignDialog(true)}
                className={`button ${styles.buttonAssign} ${deviceOnLoan ? 'btnSecondary' : 'btnPrimary'}`}
            >
                {deviceOnLoan ? t('withdraw') : t('assign')}
            </button>
            <Modal
                show={showAssignDialog}
                setShowModal={setShowAssignDialog}
            >
                {deviceOnLoan ?
                    <DialogWithdrawDevice
                        device={device}
                        widtdrawDeviceLocally={widtdrawDeviceLocally}
                        closeModal={() => setShowAssignDialog(false)}
                    />
                    :
                    <DialogAssignDevice
                        device={device}
                        assignDeviceLocally={assignDeviceLocally}
                        setShowModal={setShowAssignDialog}
                    />
                }
            </Modal>
        </>
    );
};

export default AssignDeviceButton;